module.exports = __webpack_public_path__ + "img/approved.91b473f4.svg";